import { disableInput, elementDisplay, mandatoryInput } from "../../../utils/elementControl";
// Invoice display rules abstraction
import { applyInvoiceVisibility, updateInvoiceLabel } from './invoiceRules';
import { calConvertAmt, subCatInputOnChange } from "./claimDetailUtils";
import { isElementVisible } from "../../../utils/elementControl";

const isNullOrEmpty = (value: any): boolean => value == null || value.toString() === '' || value === undefined;
const objtaxratechk = !isNullOrEmpty(localStorage.getItem("tax_rate_checking")) ? JSON.parse(localStorage.getItem("tax_rate_checking")!) : null;


// export function addTHTaxFields(cat_id_n, objRequestor, reqestorCountry) {
//     if (objRequestor.country_code == reqestorCountry) {
//         $('#ddlTransportType' + cat_id_n).on('change', function () {
//             if ($('#ddlTransportType' + cat_id_n).val() == "2" && $('#ddlCurrency' + cat_id_n).val() == 'THB') {
//                 $('#dvTHMileage' + cat_id_n).css('cssText', 'display: block !important');
//                 $('#txtTaxableamount' + cat_id_n).attr('required', 'required');
//                 $('#txtNontaxableamount' + cat_id_n).attr('required', 'required');
//                 $('#txtClaimAmount' + cat_id_n).attr('disabled', 'true');
//             }
//             else {
//                 $('#txtTaxableamount' + cat_id_n).removeAttr('required');
//                 $('#txtNontaxableamount' + cat_id_n).removeAttr('required');
//                 $('#dvTHMileage' + cat_id_n).css('cssText', 'display: none !important');
//                 $('#txtClaimAmount' + cat_id_n).removeAttr("disabled");



//                 //To handle all claim item in team mode for superior to check surbordinate claim item
//                 currentMode = getURLParam("mode");
//                 if (currentMode.toLowerCase() == 'team') {
//                     $('#txtClaimAmount' + cat_id_n).attr('disabled', 'true');
//                 }
//             }
//         })
//     }
// }

export function MatchTH_TAX_ID(i: number | undefined, 
    inputValues: { [key: string]: any | undefined },
    handleInputChange: (id: string, value?: any) => Promise<void>,
    objId:string
) {
    if (objId == `txtTaxId${i}`) {
        handleInputChange(`txtTaxNumber${i}`, inputValues[`txtTaxId${i}`]);
    }
    else {
        handleInputChange(`txtTaxId${i}`, inputValues[`txtTaxNumber${i}`]);
    }
}


export function MatchTH_Comp_Name(i: number | undefined, 
    inputValues: { [key: string]: any | undefined },
    handleInputChange: (id: string, value?: any) => Promise<void>,
    objId:string
) 
{
    if (objId == `txtWHTCompName${i}`) {
        handleInputChange(`txtCompName${i}`, inputValues[`txtWHTCompName${i}`]);
    }
    else {
        handleInputChange(`txtWHTCompName${i}`, inputValues[`txtCompName${i}`]);
    }
}


export function hideTaxableFields(
    i: number | undefined, 
    inputValues: { [key: string]: any | undefined },
    handleInputChange: (id: string, value?: any) => Promise<void>, 
    objRequestor: any, 
    requestorCountry: string,
) {
    if (objRequestor.prism_global_bu_code == 'HEC') {
        if (inputValues[`ddlCategory${i}`] == "42" && objRequestor.ee_subgroup_id == 'B4' && objRequestor.prism_global_bu_code == 'HEC') {
            elementDisplay('.dvTHMileage', false, "div");
            mandatoryInput(`#txtTaxableamount${i}`, true, "text");
            elementDisplay(`#dvNontaxableamount${i}`, true, "div");

        } else if (objRequestor.country_code == requestorCountry && (inputValues[`ddlCategory${i}`] == "41" || inputValues[`ddlCategory${i}`] == "42") && (objRequestor.ee_subgroup_id == 'B4' || objRequestor.ee_subgroup_id == 'B5' || objRequestor.ee_subgroup_id == 'B6' || objRequestor.ee_subgroup_id == 'B7' || objRequestor.ee_subgroup_id == 'B8' || objRequestor.ee_subgroup_id == 'B9' || objRequestor.ee_subgroup_id == 'C4' || objRequestor.ee_subgroup_id == 'C5' || objRequestor.ee_subgroup_id == 'C6')) {
            elementDisplay('.dvTHMileage', true, "div");
            mandatoryInput(`#txtTaxableamount${i}`, true, "text");
            handleInputChange(`txtTaxableamount${i}`, null);
            elementDisplay(`#dvNontaxableamount${i}`, false, "div");
            disableInput(`#txtTaxableamount${i}`, true, "text");
        } else {
            elementDisplay('.dvTHMileage', false, "div");
            mandatoryInput(`#txtTaxableamount${i}`, true, "text");
            elementDisplay(`#dvNontaxableamount${i}`, true, "div");
        }
    }
}


export function hideShowTaxableFields(
    i: number | undefined, 
    inputValues: { [key: string]: any | undefined },
    handleInputChange: (id: string, value?: any) => Promise<void>, 
    objRequestor: any, 
    requestorCountry: string,
    form_mode:string
) {
    if (objRequestor.country_code == requestorCountry) {
        if (objRequestor.country_code == requestorCountry && inputValues[`ddlCategory${i}`] == "4" && inputValues[`ddlTransportType${i}`] == "2" && inputValues[`ddlCurrency${i}`]  == 'THB') {
            elementDisplay('.dvTHMileage', true, "div");
            mandatoryInput(`#txtTaxableamount${i}`, true, "text");
            mandatoryInput(`#txtNontaxableamount${i}`, true, "text");
            disableInput(`#txtClaimAmount${i}`, true, "text");
        }

        else {
            //$('#dvTHMileage' + cat_id_n).css('cssText', 'display: none !important');

            elementDisplay('.dvTHMileage', false, "div");
            mandatoryInput(`#txtTaxableamount${i}`, false, "text");
            mandatoryInput(`#txtNontaxableamount${i}`, false, "text");
            handleInputChange(`txtTaxableamount${i}`, null);
            handleInputChange(`txtNontaxableamount${i}`, null);
            disableInput(`#txtClaimAmount${i}`, false, "text");

            //To handle any claim that is under view mode (form_mode)
            if (form_mode == 'view') {
                disableInput(`#txtClaimAmount${i}`, true, "text");
            }

            //To handle all claim item in team mode for superior to check surbordinate claim item
            const params = new URLSearchParams(window.location.search);
            const currentMode = params.get("mode");
            if (!isNullOrEmpty(currentMode) && currentMode?.toLowerCase() == 'team') {
                disableInput(`#txtClaimAmount${i}`, true, "text");
            }
        }
    }
}


export function employeeChildrenEducationFee(
    i: number | undefined, 
    handleInputChange: (id: string, value?: any) => Promise<void>, 
    objRequestor: any, 
    requestorCountry: string,
    cat_val:string
) {
    let syntax = '';
    const dv = document.querySelector<HTMLElement>(`#dvSubEdjuFee${i}`);
    if(dv){
        dv.innerHTML = "";
    }
    if (objRequestor.country_code == requestorCountry && cat_val == "20") {
        //TH requested to delete it
        //syntax = syntax + '<div class="form-group col-md-12 order-md-1">'
        //syntax = syntax + '<label for="ddlMaitalStatus' + cat_id_n + '" data-tag="Marital_status">Marital status</label>&nbsp;<span style="color:red;">*</span>'
        //syntax = syntax + '<select class="form-control" name="ddlfield" id="ddlMaitalStatus' + cat_id_n + '">'
        //syntax = syntax + '<option value="0"></option>'
        //syntax = syntax + '<option value="1">' + $("#Single").text()+'</option>'
        //syntax = syntax + '<option value="2">' + $("#Married").text()+'</option></select> '
        //syntax = syntax + '<div class="invalid-feedback"><span class="language">Required</span></div>'
        //syntax = syntax + '</div>'
        // syntax = syntax + '<div class="form-group col-md-12 order-md-1" style="margin-bottom:0px;">'
        // syntax = syntax + '<label for="txtBirthYear' + cat_id_n + '" data-tag="Birth_Year">Child\'s birth year</label>&nbsp;<span style="color:red;">&nbsp;*</span>'
        // syntax = syntax + '<input type="number"  autocomplete="off" class="yearpicker form-control"  id="txtBirthYear' + cat_id_n + '" style="margin-top: 0.2rem;" runningnumber="1" required>'
        // syntax = syntax + '<div class="invalid-feedback"><span class="language">Required</span></div>'
        // syntax = syntax + '</div>'

        elementDisplay(`#dvEdjuFee`, true, "div");
        elementDisplay(`#EdjuFeeAdd${i}`, true, "div");

        // $('#dvSubEdjuFee' + cat_id_n).append(syntax);
        // $("#subTitleEdjuFee" + cat_id_n).text($('#ddlCategory' + cat_id_n + ' option:selected').text())
    }
    else {
        elementDisplay(`#dvEdjuFee${i}`, false, "div");
        elementDisplay(`#EdjuFeeAdd${i}`, false, "div");
        mandatoryInput(`#txtBirthYear${i}`, false, "text");
        handleInputChange(`txtBirthYear${i}`, "");
        //$('#ddlMaitalStatus' + cat_id_n).val('0');
    }

}


export function checkEmployeeChildrenEducation_Age(
    i: number | undefined, 
    inputValues: { [key: string]: any | undefined },
) {
    let isValid = false;
    let childBirthYear = inputValues[`txtBirthYear${i}`] ;
    let receiptDate = inputValues[`txtDate`];
    let receiptYear = receiptDate.getFullYear();
    let dateDiff = receiptYear - childBirthYear;
    if (dateDiff > 5 && dateDiff <= 21)
        isValid = true;

    return isValid;
}

//Function To calculate Base VAT & WHT amount.
export function calculate_ClaimAmount(
    i: number | undefined, 
    callerID : any,
    inputValues: { [key: string]: any | undefined },
    handleInputChange: (id: string, value?: any) => Promise<void>, 
) {

    if (isNullOrEmpty(callerID))
        callerID = "";
    let vat_amount = 0, wht_amt = 0, wht_amt2 = 0;

    const objRequestor = !isNullOrEmpty(localStorage.getItem("objRequestor")) ? JSON.parse(localStorage.getItem("objRequestor")!) : null;

    if (objRequestor.country_code == "TH") {
        let actual_claimAmount = 0, tax_base_amount = 0, reciept_amt = 0;
        let vat = 0, wht = 0, wht2 = 0;
        //let vat_amount = 0, wht_amt = 0, wht_amt2 = 0;
        if (inputValues[`ddlVAT${i}`] == "1") {
            vat = 7;
        }
        //Calculate amount from Per-Diem calculation   
        if (inputValues[`hidfield_PerDiem_taxAmount${i}`]  > 0)
            reciept_amt = inputValues[`hidTax_Amount_PerDiem${i}`] ? parseFloat(inputValues[`hidTax_Amount_PerDiem${i}`].toString()) : 0;
        else
            reciept_amt = inputValues[`hidden_Init_claim_Amount${i}`] ? parseFloat(inputValues[`hidden_Init_claim_Amount${i}`].toString()) : 0;

        if (!reciept_amt) {
            reciept_amt = inputValues[`txtClaimAmount${i}`]
                ? parseFloat(inputValues[`txtClaimAmount${i}`].toString())
                : 0;
        }

        if (vat > 0) {
            if (callerID == "txtBaseAmount") {
                tax_base_amount = inputValues[`txtBaseAmount${i}`] ? parseFloat(inputValues[`txtBaseAmount${i}`].toString()) : 0;
                vat_amount = (tax_base_amount) * vat / 100;
            }
            else if (callerID == "ddlVAT") {
                if (inputValues[`txtBaseAmount${i}`] == "" || (parseFloat(inputValues[`txtBaseAmount${i}`]?.toString() || "0") == parseFloat(inputValues[`hidden_Init_claim_Amount${i}`]?.toString() || "0"))) {
                    tax_base_amount = (reciept_amt * 100) / (100 + vat);
                    vat_amount = (tax_base_amount) * vat / 100;
                }
                else {
                    tax_base_amount = inputValues[`txtBaseAmount${i}`];
                    vat_amount = (tax_base_amount) * vat / 100;
                }
            }
            else if (callerID == "txtWHTAmount" || callerID == "txtWHTAmount2" || callerID == "ddlWHT" || callerID == "ddlWHT2") {
                if (isNullOrEmpty(inputValues[`txtBaseAmount${i}`])) {
                    tax_base_amount = (reciept_amt * 100) / (100 + vat);
                    vat_amount = (tax_base_amount) * vat / 100;
                }
                else {
                    tax_base_amount = inputValues[`txtBaseAmount${i}`];
                    vat_amount = (tax_base_amount) * vat / 100;
                }
            }
            else {
                if (isNullOrEmpty(inputValues[`txtBaseAmount${i}`]) || callerID == "txtClaimAmount") {
                    tax_base_amount = (reciept_amt * 100) / (100 + vat);
                    vat_amount = (tax_base_amount) * vat / 100;
                }
                else {
                    tax_base_amount = inputValues[`txtBaseAmount${i}`];
                    vat_amount = (tax_base_amount) * vat / 100;
                }
            }
        }
        else{
            tax_base_amount = reciept_amt;
        }
            
        if (inputValues[`ddlWHT${i}`] == "1") {
            let wht_percentage = inputValues[`txtWHTPercentage${i}`] || 0;
            wht = parseFloat(((wht_percentage * tax_base_amount) / 100).toString());
            wht_amt = (wht_percentage / 100) * tax_base_amount;
        }

        if (inputValues[`ddlWHT2${i}`] == "1") {

            let wht_percentage = inputValues[`txtWHTPercentage${i}`] || 0;
            wht = parseFloat(((wht_percentage * parseFloat(inputValues[`txtWHTAmount${i}`]?.toString() || "0" )) / 100).toString());
            wht_amt = (wht_percentage / 100) * parseFloat(inputValues[`txtWHTAmount${i}`]?.toString()  || "0" );

            let wht_percentage2 = inputValues[`txtWHTPercentage2${i}`];
            wht2 = parseFloat(((wht_percentage2 * parseFloat(inputValues[`txtWHTAmount2${i}`]?.toString()  || "0" )) / 100).toString());
            wht_amt2 = (wht_percentage2 / 100) * parseFloat(inputValues[`txtWHTAmount2${i}`]?.toString() || "0");
        }

        if (inputValues[`ddlWHT2${i}`] != "1" && callerID && callerID == "txtWHTAmount") {

            let wht_percentage = inputValues[`txtWHTPercentage${i}`] || 0;
            wht = parseFloat(((wht_percentage * parseFloat(inputValues[`txtWHTAmount${i}`]?.toString() || "0" )) / 100).toString());
            wht_amt = (wht_percentage / 100) * parseFloat(inputValues[`txtWHTAmount${i}`]?.toString() || "0" );
        }

        actual_claimAmount = reciept_amt - wht - wht2;
      
        // console.log("Debug : ===>  callerID : " + callerID);
        // console.log("Debug : ===>  input : ");
        // console.log(inputValues);
        // console.log("Debug : ===>  reciept_amt : " + reciept_amt);
        // console.log("Debug : ===>  wht : " + wht);
        // console.log("Debug : ===>  wht2 : " + wht2);
        handleInputChange(`txtClaimAmount${i}`, parseFloat(actual_claimAmount.toString()).toFixed(2));

        if (inputValues[`ddlWHT2${i}`] == "1") {

        }
        else if (callerID == "txtWHTAmount") {

        }
        else {
            handleInputChange(`txtWHTAmount${i}`, parseFloat(tax_base_amount.toString()).toFixed(2));
            //WHT2 Field calculation
            handleInputChange(`txtWHTAmount2${i}`, parseFloat(tax_base_amount.toString()).toFixed(2));
        }

        if (callerID == "txtWHTAmount") {}
        else if (callerID == "txtBaseAmount") { 
            handleInputChange(`txtBaseAmount${i}`, tax_base_amount);
            handleInputChange(`txtBaseAmount2${i}`, tax_base_amount);
        }
        else {
            handleInputChange(`txtBaseAmount${i}`, parseFloat(tax_base_amount.toString()).toFixed(2));
            handleInputChange(`txtBaseAmount2${i}`, parseFloat(tax_base_amount.toString()).toFixed(2));
        }

        //$('#txtExchangeAmount' + number).val(parseFloat(actual_claimAmount).toFixed(2));
        calConvertAmt(i!, inputValues, handleInputChange, actual_claimAmount, null);

        handleInputChange('hidden_VAT_Amount', vat_amount);
        handleInputChange('hidden_WHT_Amount', wht_amt);
        handleInputChange('hidden_WHT_Amount2', wht_amt2);

        if (inputValues[`hidfield_PerDiem_taxAmount`] > 0){
            handleInputChange('hidden_Init_claim_Amount', reciept_amt);
        }
        

    }
}


export function enableVATnWHT_Section(
    i: number | undefined, 
    callerID : any,
    inputValues: { [key: string]: any | undefined },
    handleInputChange: (id: string, value?: any) => Promise<void>, 
    objAttachment:any,
) {

    //Prompt current subcategory choose by user
    let current_subcategory = inputValues[`ddlCategory${i}`];
    //Control to reset if there is no matchign subcategory selected from list json file
    let check_control_vat = true;

    //
    if (objtaxratechk) {
        if (objtaxratechk.length > 0) {
            for (let j = 0; j < objtaxratechk.length; j++) {
                if (objtaxratechk[j].current_subcategory == current_subcategory && objtaxratechk[j].include_Vat == "1") {
                    // $('.div_WHT').addClass('d-none');
                    //$('.divVat').addClass('d-none');
                    hide_WHT_Section(i, inputValues, handleInputChange);
                    hide_VAT_Section(i, handleInputChange);

                    elementDisplay(`#divVat_ddl${i}`, true, "div");

                    handleInputChange(`ddlVAT${i}`, 0);
                    handleInputChange(`txtBaseAmount${i}`, "0");
                    handleInputChange(`txtVAtPercentage${i}`, "0");
                    handleInputChange(`ddlBusinessPlace${i}`, "0");
                    handleInputChange(`txtCompName${i}`, "");
                    handleInputChange(`txtHeadOffice${i}`, "");
                    handleInputChange(`txtTaxId${i}`, "");


                    disableInput(`#txtBaseAmount${i}`, true, "text");
                    disableInput(`#txtVAtPercentage${i}`, true, "text");

                    check_control_vat = false;
                }
            }

            //Reset function when there is no matchign subcategory for VAT tax
            if (check_control_vat) {
                handleInputChange(`txtBaseAmount${i}`, 0);
                handleInputChange(`txtVAtPercentage${i}`, 0);
                handleInputChange(`ddlBusinessPlace${i}`, "");
                handleInputChange(`txtCompName${i}`, "");
                handleInputChange(`txtHeadOffice${i}`, "");
                handleInputChange(`txtTaxId${i}`, "");
            }
        }
    }

    if (objtaxratechk[0].include_Vat) {
        //$('.div_WHT').addClass('d-none');
        //$('.divVat').addClass('d-none');
        hide_VAT_Section(i, handleInputChange);
        hide_WHT_Section(i, inputValues, handleInputChange);
        elementDisplay(`#divVat_ddl${i}`, true, "div");
        elementDisplay(`#div_WHT_ddl${i}`, true, "div");
        elementDisplay(`#div_WHT_ddl2${i}`, false, "div");
        handleInputChange(`ddlVAT${i}`, 0);

        handleInputChange(`txtBaseAmount${i}`, "0");
        handleInputChange(`txtVAtPercentage${i}`, "0");
        handleInputChange(`ddlBusinessPlace${i}`, 0);
        handleInputChange(`txtCompName${i}`, "");
        handleInputChange(`txtHeadOffice${i}`, "");
        handleInputChange(`txtTaxId${i}`, "");


        disableInput(`#txtBaseAmount${i}`, true, "text");
        disableInput(`#txtVAtPercentage${i}`, true, "text");
    }
    else {
        handleInputChange(`txtBaseAmount${i}`, 0);
        handleInputChange(`txtVAtPercentage${i}`, 0);
        handleInputChange(`ddlBusinessPlace${i}`, "");
        handleInputChange(`txtCompName${i}`, "");
        handleInputChange(`txtHeadOffice${i}`, "");
        handleInputChange(`txtTaxId${i}`, "");
    }
    //Binding WHT Section
    if (objtaxratechk[0].include_Wht) {

        handleInputChange(`ddlWHT${i}`, 0);
        handleInputChange(`txtWHTAmount${i}`, parseFloat(objAttachment.base_wht_amount).toFixed(2));
        handleInputChange(`txtWHTPercentage${i}`, "0");
        handleInputChange(`txtWHTAmount${i}`, "0");
        disableInput(`#txtWHTPercentage${i}`, true, "text");

        if (inputValues[`ddlWHT2${i}`] != "1") {
            disableInput(`#txtWHTAmount${i}`, true, "text");
        }

        handleInputChange(`txtHouseNumber${i}`, "");
        handleInputChange(`txtWHTCity${i}`, "");
        handleInputChange(`txtWHTCompName${i}`, "");
        handleInputChange(`txtPostCode${i}`, "");
        handleInputChange(`txtTaxNumber${i}`, "");

        handleInputChange(`txtPayToComp${i}`, "1");
        handleInputChange(`txtPayToPerson${i}`, "0");

        elementDisplay(`#lblWHTPersonName${i}`, false, "div");
        elementDisplay(`#lblWHTCompName${i}`, true, "div");


    }
    else {
        handleInputChange(`txtWHTAmount${i}`, 0);
        handleInputChange(`txtWHTPercentage${i}`, 0);
        handleInputChange(`txtHouseNumber${i}`, "");
        handleInputChange(`txtWHTCity${i}`, "");
        handleInputChange(`txtWHTCompName${i}`, "");

        handleInputChange(`txtPostCode${i}`, "");
        handleInputChange(`txtTaxNumber${i}`, "");


    }

    if (objtaxratechk[0].include_Wht2) {
        handleInputChange(`ddlWHT2${i}`, 0);
        handleInputChange(`txtWHTAmount2${i}`, parseFloat(objAttachment.base_wht_amount2).toFixed(2));
        handleInputChange(`txtWHTPercentage2${i}`, "");
        handleInputChange(`txtWHTAmount2${i}`, "0");
        disableInput(`#txtWHTPercentage2${i}`, true, "text");

    }
    else {
        handleInputChange(`txtWHTAmount2${i}`, 0);
        handleInputChange(`txtWHTPercentage2${i}`, "");
    }

}


export function disableVATnWHT_Section(
    i: number | undefined, 
    inputValues: { [key: string]: any | undefined },
    handleInputChange: (id: string, value?: any) => Promise<void>, 
) {

    handleInputChange(`ddlVAT${i}`, 0);
    handleInputChange(`ddlWHT${i}`, 0);
    handleInputChange(`txtWHTAmount${i}`, 0);
    handleInputChange(`txtWHTPercentage${i}`, 0);
    handleInputChange(`txtBaseAmount${i}`, 0);
    handleInputChange(`txtVAtPercentage${i}`, 0);

    //WHT2 fields
    handleInputChange(`txtWHTAmount2${i}`, 0);
    handleInputChange(`txtWHTPercentage2${i}`, '');
    handleInputChange(`txtBaseAmount2${i}`, 0);
    handleInputChange(`txtVAtPercentage2${i}`, 0);

    //$('.div_WHT').addClass('d-none');
    //$('.divVat').addClass('d-none');
    hide_WHT_Section(i, inputValues, handleInputChange);
    hide_VAT_Section(i, handleInputChange);
    elementDisplay(`#divVat_ddl${i}`, false, "div");
    elementDisplay(`#div_WHT_ddl${i}`, false, "div");
    elementDisplay(`#div_WHT_ddl2${i}`, false, "div");
}

export function enable_Disable_VAT_WHT_OnLoad(
    i: number | undefined, 
    inputValues: { [key: string]: any | undefined },
    handleInputChange: (id: string, value?: any) => Promise<void>, 
    objAttachment: any, 
) {

    let current_user_information = !isNullOrEmpty(localStorage.getItem("objRequestor")) ? JSON.parse(localStorage.getItem("objRequestor")!) : null;

    handleInputChange(`hidden_WHT_Amount`, 0);
    handleInputChange(`hidden_WHT_Amount2`, 0);
    handleInputChange(`hidden_VAT_Amount`, 0);


    let objtaxratechk = !isNullOrEmpty(localStorage.getItem("tax_rate_checking")) ? JSON.parse(localStorage.getItem("tax_rate_checking")!) : null;

    if (current_user_information.country_code == 'TH' && inputValues[`ddlCurrency${i}`] == 'THB') {

        //$('#txtInvoiceNum' + i).val(objAttachment.invoice_number);
        //$('#hidOnLoad_InvoiceNum').val('1');

        //Prompt current subcategory choose by user
        let current_subcategory = inputValues[`ddlCategory${i}`];
        let cur_transport_type = inputValues[`ddlTransportType${i}`];
        let cur_phone_type = inputValues[`ddlPhoneType${i}`];
        let cur_detail_type = inputValues[`ddlDetailType${i}`];


        //Control to reset if there is no matchign subcategory selected from list json file
        let hide_control_vat = true;
        let normal_reset_vat = true;
        let hide_control_wht = true;
        let normal_reset_wht = true;

        //Enhanced VAT section
        if (!isNullOrEmpty(objtaxratechk)) {
            if (objtaxratechk.length > 0) {
                for (let j = 0; j < objtaxratechk.length; j++) {
                    //Display and bind value for VAT tax section
                    if (objtaxratechk[j].subcategory_id == current_subcategory && objtaxratechk[j].include_Vat == "1") {
                        
                        handleInputChange(`ddlVAT${i}`, objAttachment.is_include_vat);
                        elementDisplay(`#divVat_ddl${i}`, true, "div");

                        //non-detail type category
                        if (objtaxratechk[j].detail_id == null || objtaxratechk[j].detail_id == undefined) {

                            if (!isNullOrEmpty(objAttachment)) {
                                if (objAttachment.is_include_vat) {
                                    //Binding information of VAT
                                    // $('.divVat').removeClass('d-none');
                                    show_VAT_Section(i, handleInputChange);
                                    handleInputChange(`txtVAtPercentage${i}`, objAttachment.vat_percent);
                                    handleInputChange(`txtBaseAmount${i}`, objAttachment.base_vat_amount);
                                    disableInput(`#txtVAtPercentage${i}`, true, "text");
                                    disableInput(`#txtBaseAmount${i}`, true, "text");
                                    handleInputChange(`ddlBusinessPlace${i}`, objAttachment.business_place);
                                    handleInputChange(`txtCompName${i}`, objAttachment.company_name);
                                    handleInputChange(`txtHeadOffice${i}`, objAttachment.head_office);
                                    handleInputChange(`txtTaxId${i}`, objAttachment.tax_id);
                                    handleInputChange(`hidden_VAT_Amount`, objAttachment.vat_amount);
         
                                    enableBaseAmount(i, inputValues);
                                    normal_reset_vat = false
                                }
                            }

                            hide_control_vat = false;

                        }

                        else if (objtaxratechk[j].detail_id == cur_transport_type && objtaxratechk[j].subcategory_id == '4') {

                            //transport type
                            if (!isNullOrEmpty(objAttachment)) {
                                if (objAttachment.is_include_vat) {
                                    //Binding information of VAT
                                    //  $('.divVat').removeClass('d-none');
                                    show_VAT_Section(i, handleInputChange);
                                    handleInputChange(`txtVAtPercentage${i}`, objAttachment.vat_percent);
                                    handleInputChange(`txtBaseAmount${i}`, objAttachment.base_vat_amount);
                                    disableInput(`#txtVAtPercentage${i}`, true, "text");
                                    disableInput(`#txtBaseAmount${i}`, true, "text");
                                    handleInputChange(`ddlBusinessPlace${i}`, objAttachment.business_place);
                                    handleInputChange(`txtCompName${i}`, objAttachment.company_name);
                                    handleInputChange(`txtHeadOffice${i}`, objAttachment.head_office);
                                    handleInputChange(`txtTaxId${i}`, objAttachment.tax_id);
                                    handleInputChange(`hidden_VAT_Amount`, objAttachment.vat_amount);
         
                                    enableBaseAmount(i, inputValues);
                                    normal_reset_vat = false
                                }
                            }

                            hide_control_vat = false;
                        }

                        else if (objtaxratechk[j].detail_id == cur_phone_type && objtaxratechk[j].subcategory_id == '26') {

                            //phone type
                            if (!isNullOrEmpty(objAttachment)) {
                                if (objAttachment.is_include_vat) {
                                    //Binding information of VAT
                                    //  $('.divVat').removeClass('d-none');
                                    show_VAT_Section(i, handleInputChange);
                                    handleInputChange(`txtVAtPercentage${i}`, objAttachment.vat_percent);
                                    handleInputChange(`txtBaseAmount${i}`, objAttachment.base_vat_amount);
                                    disableInput(`#txtVAtPercentage${i}`, true, "text");
                                    disableInput(`#txtBaseAmount${i}`, true, "text");
                                    handleInputChange(`ddlBusinessPlace${i}`, objAttachment.business_place);
                                    handleInputChange(`txtCompName${i}`, objAttachment.company_name);
                                    handleInputChange(`txtHeadOffice${i}`, objAttachment.head_office);
                                    handleInputChange(`txtTaxId${i}`, objAttachment.tax_id);
                                    handleInputChange(`hidden_VAT_Amount`, objAttachment.vat_amount);
         
                                    enableBaseAmount(i, inputValues);
                                    normal_reset_vat = false
                                }
                            }

                            hide_control_vat = false;
                        }

                        else if (objtaxratechk[j].detail_id == cur_detail_type && objtaxratechk[j].subcategory_id == '29') {

                            //Detail type (Exclude transport & phone)
                            if (!isNullOrEmpty(objAttachment)) {
                                if (objAttachment.is_include_vat) {
                                    //Binding information of VAT
                                    show_VAT_Section(i, handleInputChange);
                                    handleInputChange(`txtVAtPercentage${i}`, objAttachment.vat_percent);
                                    handleInputChange(`txtBaseAmount${i}`, objAttachment.base_vat_amount);
                                    disableInput(`#txtVAtPercentage${i}`, true, "text");
                                    disableInput(`#txtBaseAmount${i}`, true, "text");
                                    handleInputChange(`ddlBusinessPlace${i}`, objAttachment.business_place);
                                    handleInputChange(`txtCompName${i}`, objAttachment.company_name);
                                    handleInputChange(`txtHeadOffice${i}`, objAttachment.head_office);
                                    handleInputChange(`txtTaxId${i}`, objAttachment.tax_id);
                                    handleInputChange(`hidden_VAT_Amount`, objAttachment.vat_amount);
         
                                    enableBaseAmount(i, inputValues);
                                    normal_reset_vat = false
                                }
                            }

                            hide_control_vat = false;
                        }

                    }
                } // For loop
            }
        }

        //VAT Tax default section
        //Reset function when there is no attachment and set default value to VAT Tax
        if (normal_reset_vat) {
            handleInputChange(`ddlVAT${i}`, 0);
            handleInputChange(`txtBaseAmount${i}`, 0);
            handleInputChange(`txtVAtPercentage${i}`, 0);

            handleInputChange(`ddlBusinessPlace${i}`, '');
            handleInputChange(`txtCompName${i}`, '');
            handleInputChange(`txtHeadOffice${i}`, '');
            handleInputChange(`txtTaxId${i}`, '');

            handleInputChange(`hidden_VAT_Amount`, 0);
        }
        else{
            handleInputChange(`txtClaimAmount${i}`, parseFloat(objAttachment.amount_foreign_currency.toString()).toFixed(2));
            handleInputChange(`txtExchangeAmount${i}`, parseFloat(objAttachment.total_amount.toString()).toFixed(2));
        }

        //hide function when there is no matching subcategory for VAT tax
        if (hide_control_vat) {
            elementDisplay(`#divVat_ddl${i}`, false, "div");
            //$('.divVat').addClass('d-none');
            hide_VAT_Section(i,handleInputChange);
            handleInputChange(`ddlVAT${i}`, 0);
            handleInputChange(`txtBaseAmount${i}`, 0);
            handleInputChange(`txtVAtPercentage${i}`, 0);

            handleInputChange(`ddlBusinessPlace${i}`, '');
            handleInputChange(`txtCompName${i}`, '');
            handleInputChange(`txtHeadOffice${i}`, '');
            handleInputChange(`txtTaxId${i}`, '');

            handleInputChange(`hidden_VAT_Amount`, 0);
        }
        //end of vat tax default section

        //Enhanced WHT section
        if (objtaxratechk) {
            if (objtaxratechk.length > 0) {
                for (let j = 0; j < objtaxratechk.length; j++) {
                    //Display and bind value for VAT tax section
                    if (objtaxratechk[j].subcategory_id == current_subcategory && objtaxratechk[j].include_Wht == "1") {
                        elementDisplay(`#div_WHT_ddl${i}`, true, "div");

                        //Non-detail type category
                        if (objtaxratechk[j].detail_id == null || objtaxratechk[j].detail_id == undefined) {

                            if (!isNullOrEmpty(objAttachment)) {
                                if (objAttachment.is_include_wht) {
                                    handleInputChange(`ddlWHT${i}`, objAttachment.is_include_wht);
                                    handleInputChange(`ddlWHT2${i}`, objAttachment.is_include_wht2);
                                    if (objAttachment.is_include_wht > 0){
                                        elementDisplay(`#div_WHT_ddl2${i}`, true, "div");
                                    }
                                    //$('.div_WHT').removeClass('d-none');
                                    show_WHT_Section(i, inputValues, handleInputChange);
                                    enableBaseAmount(i, inputValues);

                                    handleInputChange(`txtWHTAmount${i}`, objAttachment.base_wht_amount);
                                    handleInputChange(`txtWHTPercentage${i}`, objAttachment.wht_percent);

                                    if (inputValues[`ddlWHT2${i}`] != 1) {
                                        disableInput(`#txtWHTAmount${i}`, true, "text");
                                    }
                                    handleInputChange(`txtWHTPercentage${i}`, objAttachment.wht_percent);
                                    disableInput(`#txtWHTPercentage${i}`, true, "text");

                                    handleInputChange(`txtHouseNumber${i}`, objAttachment.house_number);
                                    handleInputChange(`txtWHTCity${i}`, objAttachment.wht_city);
                                    handleInputChange(`txtWHTCompName${i}`, objAttachment.wht_name);
                                    handleInputChange(`txtPostCode${i}`, objAttachment.postcode);
                                    handleInputChange(`txtTaxNumber${i}`, objAttachment.tax_number);
                                    handleInputChange(`hidden_WHT_Amount${i}`, objAttachment.wht_amount);

                                    //WHT No 2 
                                    if (objAttachment.is_include_wht2) {
                                        handleInputChange(`txtWHTAmount2${i}`, objAttachment.base_wht_amount2);
                                        handleInputChange(`txtWHTPercentage2${i}`, objAttachment.wht_percent2);
                                        disableInput(`#txtWHTPercentage2${i}`, true, "text");
                                        handleInputChange(`hidden_WHT_Amount2`, objAttachment.wht_amount2);


                                        if (objAttachment.wht_type2 == 0) {
                                            handleInputChange(`txtThreePerc2${i}`, "0");
                                            handleInputChange(`txtFivePer2${i}`, "0");
                                            handleInputChange(`txtOnePerc2${i}`, "0");
                                            disableInput(`#txtWHTPercentage2${i}`, true, "text");
                                        }

                                        //WHT2 tax rate
                                        if (objAttachment.wht_type2 == 1) {
                                            handleInputChange(`txtThreePerc2${i}`, "0");
                                            handleInputChange(`txtFivePer2${i}`, "0");

                                            if (isElementVisible('#divWHT_TypeOne2' + i)) {
                                                handleInputChange(`txtOnePerc2${i}`, "1");
                                            }
                                            else {
                                                 handleInputChange(`txtOnePerc2${i}`, "0");

                                                if (inputValues[`txtWHTPercentage2${i}`] == "1") {
                                                    disableInput(`#txtWHTPercentage2${i}`, true, "text");
                                                }
                                            }
                                        }
                                        else if (objAttachment.wht_type2 == 2) {
                                            handleInputChange(`txtOnePerc2${i}`, "0");
                                            handleInputChange(`txtFivePer2${i}`, "0");

                                            if (isElementVisible('#divWHT_TypeThree2' + i)) {
                                                handleInputChange(`txtThreePerc2${i}`, "1");
                                            }
                                            else {
                                                handleInputChange(`txtThreePerc2${i}`, "0");

                                                if (inputValues[`txtWHTPercentage2${i}`] == "3") {
                                                    handleInputChange(`txtWHTPercentage2${i}`, "");
                                                    disableInput(`#txtWHTPercentage2${i}`, true, "text");
                                                }
                                            }
                                        }
                                        else if (objAttachment.wht_type2 == 3) {
                                            handleInputChange(`txtOnePerc2${i}`, "0");
                                            handleInputChange(`txtThreePerc2${i}`, "0");

                                            if (isElementVisible('#divWHT_TypeFive2' + i)) {
                                                handleInputChange(`txtFivePer2${i}`, "1");
                                            }
                                            else {
                                                handleInputChange(`txtFivePer2${i}`, "0");

                                                if (inputValues[`txtWHTPercentage2${i}`] == "1") {
                                                    handleInputChange(`txtWHTPercentage2${i}`, "");
                                                    disableInput(`#txtWHTPercentage2${i}`, true, "text");
                                                }
                                            }
                                        }
                                    }


                                    //WHT Payment type
                                    if (objAttachment.wht_pay_to == 1 || objAttachment.wht_pay_to == '' || objAttachment.wht_pay_to == null || objAttachment.wht_pay_to == undefined) {
                                        handleInputChange(`txtPayToComp${i}`, "1");
                                        handleInputChange(`txtPayToPerson${i}`, "0");
                                        elementDisplay(`#lblWHTPersonName${i}`, false, "div");
                                        elementDisplay(`#lblWHTCompName${i}`, true, "div");
                                        disableInput(`#ddlWHT2${i}`, false, "select");

                                    }
                                    if (objAttachment.wht_pay_to == 2) {
                                        handleInputChange(`txtPayToPerson${i}`, "1");
                                        handleInputChange(`txtPayToComp${i}`, "0");
                                        elementDisplay(`#lblWHTPersonName${i}`, true, "div");
                                        elementDisplay(`#lblWHTCompName${i}`, false, "div");

                                        handleInputChange(`ddlWHT2${i}`, "0");
                                        subCatInputOnChange(inputValues, i, 'ddlWHT2', handleInputChange, "0");
                                        disableInput(`#ddlWHT2${i}`, true, "select");
                                    }

                                    if (objAttachment.wht_type == 0) {
                                        handleInputChange(`txtThreePerc${i}`, "0");
                                        handleInputChange(`txtFivePer${i}`, "0");
                                        handleInputChange(`txtOnePerc${i}`, "0");
                                        disableInput(`#txtWHTPercentage${i}`, true, "text");

                                    }

                                    //WHT tax rate
                                    if (objAttachment.wht_type == 1 || objAttachment.wht_type == '' || objAttachment.wht_type == null || objAttachment.wht_type == undefined) {

                                        if (isElementVisible('#divWHT_TypeOne' + i)) {
                                            handleInputChange(`txtOnePerc${i}`, "1");
                                        }
                                        else {
                                            handleInputChange(`txtOnePerc${i}`, "0");

                                            if (inputValues[`txtWHTPercentage${i}`] == "1") {
                                                disableInput(`#txtWHTPercentage${i}`, true, "text");
                                                
                                            }
                                        }
                                        handleInputChange(`txtThreePerc${i}`, "0");
                                        handleInputChange(`txtFivePer${i}`, "0");
                                    }
                                    else if (objAttachment.wht_type == 2) {
                                        if (isElementVisible('#divWHT_TypeThree' + i)) {
                                            handleInputChange(`txtThreePerc${i}`, "1");
                                        }
                                        else {
                                            handleInputChange(`txtThreePerc${i}`, "0");

                                            if (inputValues[`txtWHTPercentage${i}`] == "3") {
                                                disableInput(`#txtWHTPercentage${i}`, true, "text");
                                            }
                                        }
                                        handleInputChange(`txtOnePerc${i}`, "0");
                                        handleInputChange(`txtFivePer${i}`, "0");
                                    }
                                    else if (objAttachment.wht_type == 3) {
                                        if (isElementVisible('#divWHT_TypeFive' + i)) {
                                            
                                            handleInputChange(`txtFivePer${i}`, "0");
                                        }
                                        else {
                                            handleInputChange(`txtFivePer${i}`, "0");

                                            if (inputValues[`txtWHTPercentage${i}`] == "5") {
                                                handleInputChange(`txtWHTPercentage${i}`, "");
                                                disableInput(`#txtWHTPercentage${i}`, true, "text");

                                            }
                                        }
                                        handleInputChange(`txtOnePerc${i}`, "0");
                                        handleInputChange(`txtThreePerc${i}`, "0");

                                    }


                                    enableBaseAmount(i, inputValues);
                                    normal_reset_wht = false;

                                }
                            }

                            hide_control_wht = false;
                        }
                        //Transport type category
                        else if (objtaxratechk[j].detail_id == cur_transport_type && objtaxratechk[j].subcategory_id == '4') {

                            if (!isNullOrEmpty(objAttachment)) {
                                if (objAttachment.is_include_wht) {
                                    handleInputChange(`ddlWHT${i}`, objAttachment.is_include_wht);
                                    handleInputChange(`ddlWHT2${i}`, objAttachment.is_include_wht2);
                                    if (objAttachment.is_include_wht > 0){
                                        elementDisplay('#div_WHT_ddl2' + i, true, "div");
                                    }
                                    // $('.div_WHT').removeClass('d-none');
                                    show_WHT_Section(i,inputValues,handleInputChange);
                                    enableBaseAmount(i, inputValues);
                                    handleInputChange(`txtWHTAmount${i}`, objAttachment.base_wht_amount);
                                    handleInputChange(`txtWHTPercentage${i}`, objAttachment.wht_percent);

                                    if (inputValues[`ddlWHT2${i}`] != 1) {
                                        disableInput(`#txtWHTAmount${i}`, true, "text");
                                    }

                                    handleInputChange(`txtWHTPercentage${i}`, objAttachment.wht_percent);
                                    disableInput(`#txtWHTPercentage${i}`, true, "text");
                                    handleInputChange(`txtHouseNumber${i}`, objAttachment.house_number);
                                    handleInputChange(`txtWHTCity${i}`, objAttachment.wht_city);
                                    handleInputChange(`txtWHTCompName${i}`, objAttachment.wht_name);
                                    handleInputChange(`txtPostCode${i}`, objAttachment.postcode);
                                    handleInputChange(`txtTaxNumber${i}`, objAttachment.tax_number);
                                    handleInputChange(`hidden_WHT_Amount${i}`, objAttachment.wht_amount);

                                    // WHT2 Section
                                    if (objAttachment.is_include_wht2) {

                                        handleInputChange(`txtWHTAmount2${i}`, objAttachment.base_wht_amount2);
                                        handleInputChange(`txtWHTPercentage2${i}`, objAttachment.wht_percent2);
                                        disableInput(`#txtWHTPercentage2${i}`, true, "text");
                                        handleInputChange(`hidden_WHT_Amount2`, objAttachment.wht_amount2);

                                        if (objAttachment.wht_type2 == 0) {
                                            handleInputChange(`txtThreePerc2${i}`, "0");
                                            handleInputChange(`txtFivePer2${i}`, "0");
                                            handleInputChange(`txtOnePerc2${i}`, "0");
                                            handleInputChange(`txtWHTPercentage2${i}`, "");
                                            disableInput(`#txtWHTPercentage2${i}`, true, "text");
                                        }

                                        //WHT2 tax rate
                                        if (objAttachment.wht_type2 == 1) {
                                            handleInputChange(`txtThreePerc2${i}`, "0");
                                            handleInputChange(`txtFivePer2${i}`, "0");

                                            if (isElementVisible('#divWHT_TypeOne2' + i)) {
                                                handleInputChange(`txtOnePerc2${i}`, "1");
                                            }
                                            else {
                                                handleInputChange(`txtOnePerc2${i}`, "0");

                                                if (inputValues[`txtWHTPercentage2${i}`] == "1") {
                                                    handleInputChange(`txtWHTPercentage2${i}`, "");
                                                    disableInput(`#txtWHTPercentage2${i}`, true, "text");
                                                }
                                            }
                                        }
                                        else if (objAttachment.wht_type2 == 2) {
                                            handleInputChange(`txtOnePerc2${i}`, "0");
                                            handleInputChange(`txtFivePer2${i}`, "0");

                                            if (isElementVisible('#divWHT_TypeThree2' + i)) {
                                                handleInputChange(`txtThreePerc2${i}`, "1");
                                            }
                                            else {
                                                handleInputChange(`txtThreePerc2${i}`, "0");

                                                if (inputValues[`txtWHTPercentage2${i}`] == "3") {
                                                    handleInputChange(`txtWHTPercentage2${i}`, "");
                                                    disableInput(`#txtWHTPercentage2${i}`, true, "text");
                                                }
                                            }
                                        }
                                        else if (objAttachment.wht_type2 == 3) {
                                            handleInputChange(`txtOnePerc2${i}`, "0");
                                            handleInputChange(`txtThreePerc2${i}`, "0");

                                            if (isElementVisible('#divWHT_TypeFive2' + i)) {
                                                handleInputChange(`txtFivePer2${i}`, "1");
                                            }
                                            else {
                                                handleInputChange(`txtFivePer2${i}`, "0");

                                                if (inputValues[`txtWHTPercentage2${i}`] == "1") {
                                                    handleInputChange(`txtWHTPercentage2${i}`, "");
                                                    disableInput(`#txtWHTPercentage2${i}`, true, "text");
                                                }
                                            }
                                        }
                                    }

                                    //WHT Payment type
                                    if (objAttachment.wht_pay_to == 1 || objAttachment.wht_pay_to == '' || objAttachment.wht_pay_to == null || objAttachment.wht_pay_to == undefined) {
                                        handleInputChange(`txtPayToComp${i}`, "1");
                                        handleInputChange(`txtPayToPerson${i}`, "0");
                                        elementDisplay(`#lblWHTPersonName${i}`, false, "div");
                                        elementDisplay(`#lblWHTCompName${i}`, true, "div");

                                    }
                                    if (objAttachment.wht_pay_to == 2) {
                                        handleInputChange(`txtPayToPerson${i}`, "1");
                                        handleInputChange(`txtPayToComp${i}`, "0");
                                        elementDisplay(`#lblWHTPersonName${i}`, true, "div");
                                        elementDisplay(`#lblWHTCompName${i}`, false, "div");
                                    }

                                    if (objAttachment.wht_type == 0) {
                                        handleInputChange(`txtThreePerc${i}`, "0");
                                        handleInputChange(`txtFivePer${i}`, "0");
                                        handleInputChange(`txtOnePerc${i}`, "0");
                                        handleInputChange(`txtWHTPercentage${i}`, "");
                                        disableInput(`#txtWHTPercentage${i}`, true, "text");
                                    }

                                    //WHT tax rate
                                    if (objAttachment.wht_type == 1 || objAttachment.wht_type == '' || objAttachment.wht_type == null || objAttachment.wht_type == undefined) {
                                        handleInputChange(`txtThreePerc${i}`, "0");
                                        handleInputChange(`txtFivePer${i}`, "0");

                                        if (isElementVisible('#divWHT_TypeOne' + i)) {
                                            handleInputChange(`txtOnePerc${i}`, "1");
                                        }
                                        else {
                                            handleInputChange(`txtOnePerc${i}`, "0");

                                            if (inputValues[`txtWHTPercentage${i}`] == "1") {
                                                handleInputChange(`txtWHTPercentage${i}`, "");
                                                disableInput(`#txtWHTPercentage${i}`, true, "text");
                                            }
                                        }

                                    }
                                    else if (objAttachment.wht_type == 2) {
                                        handleInputChange(`txtOnePerc${i}`, "0");
                                        handleInputChange(`txtFivePer${i}`, "0");

                                        if (isElementVisible('#divWHT_TypeThree' + i)) {
                                            handleInputChange(`txtThreePerc${i}`, "1");
                                        }
                                        else {
                                            handleInputChange(`txtThreePerc${i}`, "0");

                                            if (inputValues[`txtWHTPercentage${i}`] == "3") {
                                                handleInputChange(`txtWHTPercentage${i}`, "");
                                                disableInput(`#txtWHTPercentage${i}`, true, "text");
                                            }
                                        }
                                    }
                                    else if (objAttachment.wht_type == 3) {
                                        handleInputChange(`txtOnePerc${i}`, "0");
                                        handleInputChange(`txtThreePerc${i}`, "0");

                                        if (isElementVisible('#divWHT_TypeFive' + i) ) {
                                            handleInputChange(`txtFivePer${i}`, "1");
                                        }
                                        else {
                                            handleInputChange(`txtFivePer${i}`, "0");

                                            if (inputValues[`txtWHTPercentage${i}`] == "5") {
                                                handleInputChange(`txtWHTPercentage${i}`, "");
                                                disableInput(`#txtWHTPercentage${i}`, true, "text");
                                            }
                                        }
                                    }


                                    enableBaseAmount(i, inputValues);
                                    normal_reset_wht = false;

                                }
                            }

                            hide_control_wht = false;
                        }
                        //Phone Type category
                        else if (objtaxratechk[j].detail_id == cur_phone_type && objtaxratechk[j].subcategory_id == '26') {

                            if (!isNullOrEmpty(objAttachment)) {
                                if (objAttachment.is_include_wht) {
                                    handleInputChange(`ddlWHT${i}`, objAttachment.is_include_wht);
                                    handleInputChange(`ddlWHT2${i}`, objAttachment.is_include_wht2);
                                    if (objAttachment.is_include_wht > 0){
                                        elementDisplay('#div_WHT_ddl2' + i, true, "div");
                                    }
                                    // $('.div_WHT').removeClass('d-none');
                                    show_WHT_Section(i,inputValues,handleInputChange);
                                    enableBaseAmount(i, inputValues);
                                    handleInputChange(`txtWHTAmount${i}`, objAttachment.base_wht_amount);
                                    handleInputChange(`txtWHTPercentage${i}`, objAttachment.wht_percent);

                                    if (inputValues[`ddlWHT2${i}`] != 1) {
                                        disableInput(`#txtWHTAmount${i}`, true, "text");
                                    }

                                    handleInputChange(`txtWHTPercentage${i}`, objAttachment.wht_percent);
                                    disableInput(`#txtWHTPercentage${i}`, true, "text");
                                    handleInputChange(`txtHouseNumber${i}`, objAttachment.house_number);
                                    handleInputChange(`txtWHTCity${i}`, objAttachment.wht_city);
                                    handleInputChange(`txtWHTCompName${i}`, objAttachment.wht_name);
                                    handleInputChange(`txtPostCode${i}`, objAttachment.postcode);
                                    handleInputChange(`txtTaxNumber${i}`, objAttachment.tax_number);
                                    handleInputChange(`hidden_WHT_Amount${i}`, objAttachment.wht_amount);

                                    // WHT2 Section
                                    if (objAttachment.is_include_wht2) {

                                        handleInputChange(`txtWHTAmount2${i}`, objAttachment.base_wht_amount2);
                                        handleInputChange(`txtWHTPercentage2${i}`, objAttachment.wht_percent2);
                                        disableInput(`#txtWHTPercentage2${i}`, true, "text");
                                        handleInputChange(`hidden_WHT_Amount2`, objAttachment.wht_amount2);

                                        if (objAttachment.wht_type2 == 0) {
                                            handleInputChange(`txtThreePerc2${i}`, "0");
                                            handleInputChange(`txtFivePer2${i}`, "0");
                                            handleInputChange(`txtOnePerc2${i}`, "0");
                                            handleInputChange(`txtWHTPercentage2${i}`, "");
                                            disableInput(`#txtWHTPercentage2${i}`, true, "text");
                                        }

                                        //WHT2 tax rate
                                        if (objAttachment.wht_type2 == 1) {
                                            handleInputChange(`txtThreePerc2${i}`, "0");
                                            handleInputChange(`txtFivePer2${i}`, "0");

                                            if (isElementVisible('#divWHT_Type2' + i)) {
                                                handleInputChange(`txtOnePerc2${i}`, "1");
                                            }
                                            else {
                                                handleInputChange(`txtOnePerc2${i}`, "0");

                                                if (inputValues[`txtWHTPercentage2${i}`] == "1") {
                                                    handleInputChange(`txtWHTPercentage2${i}`, "");
                                                    disableInput(`#txtWHTPercentage2${i}`, true, "text");
                                                }
                                            }
                                        }
                                        else if (objAttachment.wht_type2 == 2) {
                                            handleInputChange(`txtOnePerc2${i}`, "0");
                                            handleInputChange(`txtFivePer2${i}`, "0");

                                            if (isElementVisible('#divWHT_TypeThree2' + i)) {
                                                handleInputChange(`txtThreePerc2${i}`, "1");
                                            }
                                            else {
                                                handleInputChange(`txtThreePerc2${i}`, "0");

                                                if (inputValues[`txtWHTPercentage2${i}`] == "3") {
                                                    handleInputChange(`txtWHTPercentage2${i}`, "");
                                                    disableInput(`#txtWHTPercentage2${i}`, true, "text");
                                                }
                                            }
                                        }
                                        else if (objAttachment.wht_type2 == 3) {
                                            handleInputChange(`txtOnePerc2${i}`, "0");
                                            handleInputChange(`txtThreePerc2${i}`, "0");

                                            if (isElementVisible('#divWHT_TypeFive2' + i)) {
                                                handleInputChange(`txtFivePer2${i}`, "1");
                                            }
                                            else {
                                                handleInputChange(`txtFivePer2${i}`, "0");

                                                if (inputValues[`txtWHTPercentage2${i}`] == "1") {
                                                    handleInputChange(`txtWHTPercentage2${i}`, "");
                                                    disableInput(`#txtWHTPercentage2${i}`, true, "text");
                                                }
                                            }
                                        }
                                    }

                                    //WHT Payment type
                                    if (objAttachment.wht_pay_to == 1 || objAttachment.wht_pay_to == '' || objAttachment.wht_pay_to == null || objAttachment.wht_pay_to == undefined) {
                                        handleInputChange(`txtPayToComp${i}`, "1");
                                        handleInputChange(`txtPayToPerson${i}`, "0");
                                        elementDisplay(`#lblWHTPersonName${i}`, false, "div");
                                        elementDisplay(`#lblWHTCompName${i}`, true, "div");

                                    }
                                    if (objAttachment.wht_pay_to == 2) {
                                        handleInputChange(`txtPayToPerson${i}`, "1");
                                        handleInputChange(`txtPayToComp${i}`, "0");
                                        elementDisplay(`#lblWHTPersonName${i}`, true, "div");
                                        elementDisplay(`#lblWHTCompName${i}`, false, "div");
                                    }

                                    if (objAttachment.wht_type == 0) {
                                        handleInputChange(`txtThreePerc${i}`, "0");
                                        handleInputChange(`txtFivePer${i}`, "0");
                                        handleInputChange(`txtOnePerc${i}`, "0");
                                        handleInputChange(`txtWHTPercentage${i}`, "");
                                        disableInput(`#txtWHTPercentage${i}`, true, "text");
                                    }

                                    //WHT tax rate
                                    if (objAttachment.wht_type == 1 || objAttachment.wht_type == '' || objAttachment.wht_type == null || objAttachment.wht_type == undefined) {
                                        handleInputChange(`txtThreePerc${i}`, "0");
                                        handleInputChange(`txtFivePer${i}`, "0");

                                        if (isElementVisible('#divWHT_TypeOne' + i)) {
                                            handleInputChange(`txtOnePerc${i}`, "1");
                                        }
                                        else {
                                            handleInputChange(`txtOnePerc${i}`, "0");

                                            if (inputValues[`txtWHTPercentage${i}`] == "1") {
                                                handleInputChange(`txtWHTPercentage${i}`, "");
                                                disableInput(`#txtWHTPercentage${i}`, true, "text");
                                            }
                                        }

                                    }
                                    else if (objAttachment.wht_type == 2) {
                                        handleInputChange(`txtOnePerc${i}`, "0");
                                        handleInputChange(`txtFivePer${i}`, "0");

                                        if (isElementVisible('#divWHT_TypeThree' + i)) {
                                            handleInputChange(`txtThreePerc${i}`, "1");
                                        }
                                        else {
                                            handleInputChange(`txtThreePerc${i}`, "0");

                                            if (inputValues[`txtWHTPercentage${i}`] == "3") {
                                                handleInputChange(`txtWHTPercentage${i}`, "");
                                                disableInput(`#txtWHTPercentage${i}`, true, "text");
                                            }
                                        }
                                    }
                                    else if (objAttachment.wht_type == 3) {
                                        handleInputChange(`txtOnePerc${i}`, "0");
                                        handleInputChange(`txtThreePerc${i}`, "0");

                                        if (isElementVisible('#divWHT_TypeFive' + i) ) {
                                            handleInputChange(`txtFivePer${i}`, "1");
                                        }
                                        else {
                                            handleInputChange(`txtFivePer${i}`, "0");

                                            if (inputValues[`txtWHTPercentage${i}`] == "5") {
                                                handleInputChange(`txtWHTPercentage${i}`, "");
                                                disableInput(`#txtWHTPercentage${i}`, true, "text");
                                            }
                                        }
                                    }


                                    enableBaseAmount(i, inputValues);
                                    normal_reset_wht = false;

                                }
                            }

                            hide_control_wht = false;
                        }

                        //Detail Type category (Exclude transport & phone)
                        else if (objtaxratechk[j].detail_id == cur_detail_type && objtaxratechk[j].subcategory_id == '29') {

                            if (!isNullOrEmpty(objAttachment)) {
                                if (objAttachment.is_include_wht) {
                                    handleInputChange(`ddlWHT${i}`, objAttachment.is_include_wht);
                                    handleInputChange(`ddlWHT2${i}`, objAttachment.is_include_wht2);
                                    if (objAttachment.is_include_wht > 0){
                                        elementDisplay('#div_WHT_ddl2' + i, true, "div");
                                    }
                                    // $('.div_WHT').removeClass('d-none');
                                    show_WHT_Section(i,inputValues,handleInputChange);
                                    enableBaseAmount(i, inputValues);
                                    handleInputChange(`txtWHTAmount${i}`, objAttachment.base_wht_amount);
                                    handleInputChange(`txtWHTPercentage${i}`, objAttachment.wht_percent);

                                    if (inputValues[`ddlWHT2${i}`] != 1) {
                                        disableInput(`#txtWHTAmount${i}`, true, "text");
                                    }

                                    handleInputChange(`txtWHTPercentage${i}`, objAttachment.wht_percent);
                                    disableInput(`#txtWHTPercentage${i}`, true, "text");
                                    handleInputChange(`txtHouseNumber${i}`, objAttachment.house_number);
                                    handleInputChange(`txtWHTCity${i}`, objAttachment.wht_city);
                                    handleInputChange(`txtWHTCompName${i}`, objAttachment.wht_name);
                                    handleInputChange(`txtPostCode${i}`, objAttachment.postcode);
                                    handleInputChange(`txtTaxNumber${i}`, objAttachment.tax_number);
                                    handleInputChange(`hidden_WHT_Amount${i}`, objAttachment.wht_amount);

                                    // WHT2 Section
                                    if (objAttachment.is_include_wht2) {

                                        handleInputChange(`txtWHTAmount2${i}`, objAttachment.base_wht_amount2);
                                        handleInputChange(`txtWHTPercentage2${i}`, objAttachment.wht_percent2);
                                        disableInput(`#txtWHTPercentage2${i}`, true, "text");
                                        handleInputChange(`hidden_WHT_Amount2`, objAttachment.wht_amount2);

                                        if (objAttachment.wht_type2 == 0) {
                                            handleInputChange(`txtThreePerc2${i}`, "0");
                                            handleInputChange(`txtFivePer2${i}`, "0");
                                            handleInputChange(`txtOnePerc2${i}`, "0");
                                            handleInputChange(`txtWHTPercentage2${i}`, "");
                                            disableInput(`#txtWHTPercentage2${i}`, true, "text");
                                        }

                                        //WHT2 tax rate
                                        if (objAttachment.wht_type2 == 1) {
                                            handleInputChange(`txtThreePerc2${i}`, "0");
                                            handleInputChange(`txtFivePer2${i}`, "0");

                                            if (isElementVisible('#divWHT_Type2' + i)) {
                                                handleInputChange(`txtOnePerc2${i}`, "1");
                                            }
                                            else {
                                                handleInputChange(`txtOnePerc2${i}`, "0");

                                                if (inputValues[`txtWHTPercentage2${i}`] == "1") {
                                                    handleInputChange(`txtWHTPercentage2${i}`, "");
                                                    disableInput(`#txtWHTPercentage2${i}`, true, "text");
                                                }
                                            }
                                        }
                                        else if (objAttachment.wht_type2 == 2) {
                                            handleInputChange(`txtOnePerc2${i}`, "0");
                                            handleInputChange(`txtFivePer2${i}`, "0");

                                            if (isElementVisible('#divWHT_TypeThree2' + i)) {
                                                handleInputChange(`txtThreePerc2${i}`, "1");
                                            }
                                            else {
                                                handleInputChange(`txtThreePerc2${i}`, "0");

                                                if (inputValues[`txtWHTPercentage2${i}`] == "3") {
                                                    handleInputChange(`txtWHTPercentage2${i}`, "");
                                                    disableInput(`#txtWHTPercentage2${i}`, true, "text");
                                                }
                                            }
                                        }
                                        else if (objAttachment.wht_type2 == 3) {
                                            handleInputChange(`txtOnePerc2${i}`, "0");
                                            handleInputChange(`txtThreePerc2${i}`, "0");

                                            if (isElementVisible('#divWHT_TypeFive2' + i)) {
                                                handleInputChange(`txtFivePer2${i}`, "1");
                                            }
                                            else {
                                                handleInputChange(`txtFivePer2${i}`, "0");

                                                if (inputValues[`txtWHTPercentage2${i}`] == "5") {
                                                    handleInputChange(`txtWHTPercentage2${i}`, "");
                                                    disableInput(`#txtWHTPercentage2${i}`, true, "text");
                                                }
                                            }
                                        }
                                    }

                                    //WHT Payment type
                                    if (objAttachment.wht_pay_to == 1 || objAttachment.wht_pay_to == '' || objAttachment.wht_pay_to == null || objAttachment.wht_pay_to == undefined) {
                                        handleInputChange(`txtPayToComp${i}`, "1");
                                        handleInputChange(`txtPayToPerson${i}`, "0");
                                        elementDisplay(`#lblWHTPersonName${i}`, false, "div");
                                        elementDisplay(`#lblWHTCompName${i}`, true, "div");

                                    }
                                    if (objAttachment.wht_pay_to == 2) {
                                        handleInputChange(`txtPayToPerson${i}`, "1");
                                        handleInputChange(`txtPayToComp${i}`, "0");
                                        elementDisplay(`#lblWHTPersonName${i}`, true, "div");
                                        elementDisplay(`#lblWHTCompName${i}`, false, "div");
                                    }

                                    if (objAttachment.wht_type == 0) {
                                        handleInputChange(`txtThreePerc${i}`, "0");
                                        handleInputChange(`txtFivePer${i}`, "0");
                                        handleInputChange(`txtOnePerc${i}`, "0");
                                        handleInputChange(`txtWHTPercentage${i}`, "");
                                        disableInput(`#txtWHTPercentage${i}`, true, "text");
                                    }

                                    //WHT tax rate
                                    if (objAttachment.wht_type == 1 || objAttachment.wht_type == '' || objAttachment.wht_type == null || objAttachment.wht_type == undefined) {
                                        handleInputChange(`txtThreePerc${i}`, "0");
                                        handleInputChange(`txtFivePer${i}`, "0");

                                        if (isElementVisible('#divWHT_TypeOne' + i)) {
                                            handleInputChange(`txtOnePerc${i}`, "1");
                                        }
                                        else {
                                            handleInputChange(`txtOnePerc${i}`, "0");

                                            if (inputValues[`txtWHTPercentage${i}`] == "1") {
                                                handleInputChange(`txtWHTPercentage${i}`, "");
                                                disableInput(`#txtWHTPercentage${i}`, true, "text");
                                            }
                                        }

                                    }
                                    else if (objAttachment.wht_type == 2) {
                                        handleInputChange(`txtOnePerc${i}`, "0");
                                        handleInputChange(`txtFivePer${i}`, "0");

                                        if (isElementVisible('#divWHT_TypeThree' + i)) {
                                            handleInputChange(`txtThreePerc${i}`, "1");
                                        }
                                        else {
                                            handleInputChange(`txtThreePerc${i}`, "0");

                                            if (inputValues[`txtWHTPercentage${i}`] == "3") {
                                                handleInputChange(`txtWHTPercentage${i}`, "");
                                                disableInput(`#txtWHTPercentage${i}`, true, "text");
                                            }
                                        }
                                    }
                                    else if (objAttachment.wht_type == 3) {
                                        handleInputChange(`txtOnePerc${i}`, "0");
                                        handleInputChange(`txtThreePerc${i}`, "0");

                                        if (isElementVisible('#divWHT_TypeFive' + i) ) {
                                            handleInputChange(`txtFivePer${i}`, "1");
                                        }
                                        else {
                                            handleInputChange(`txtFivePer${i}`, "0");

                                            if (inputValues[`txtWHTPercentage${i}`] == "5") {
                                                handleInputChange(`txtWHTPercentage${i}`, "");
                                                disableInput(`#txtWHTPercentage${i}`, true, "text");
                                            }
                                        }
                                    }


                                    enableBaseAmount(i, inputValues);
                                    normal_reset_wht = false;

                                }
                            }

                            hide_control_wht = false;
                        }

                    }
                }
            }
        }


        //WHT Tax default section
        if (normal_reset_wht) {
            handleInputChange(`ddlWHT${i}`, "0");
            handleInputChange(`txtWHTAmount${i}`, "0");
            handleInputChange(`txtWHTPercentage${i}`, "0");
            handleInputChange(`txtHouseNumber${i}`, "");
            handleInputChange(`txtWHTCity${i}`, "");
            handleInputChange(`txtWHTCompName${i}`, "");
            handleInputChange(`txtPostCode${i}`, "");
            handleInputChange(`txtTaxNumber${i}`, "");

            handleInputChange(`txtPayToComp${i}`, "0");
            handleInputChange(`txtPayToPerson${i}`, "0");
            handleInputChange(`txtOnePerc${i}`, "0");
            handleInputChange(`txtThreePerc${i}`, "0");
            handleInputChange(`txtFivePer${i}`, "0");
            handleInputChange(`hidden_WHT_Amount${i}`, objAttachment.wht_amount);

            //WHT2 section
            handleInputChange(`txtWHTAmount2${i}`, "0");
            handleInputChange(`txtWHTPercentage2${i}`, "");

            handleInputChange(`txtOnePerc2${i}`, "0");
            handleInputChange(`txtThreePerc2${i}`, "0");
            handleInputChange(`txtFivePer2${i}`, "0");
            handleInputChange(`hidden_WHT_Amount2`, objAttachment.wht_amount2);

        }
        else{
            handleInputChange(`txtClaimAmount${i}`, parseFloat(objAttachment.amount_foreign_currency.toString()).toFixed(2));
            handleInputChange(`txtExchangeAmount${i}`, parseFloat(objAttachment.total_amount.toString()).toFixed(2));
        }

        if (hide_control_wht) {
            // $('.div_WHT').addClass('d-none');
            hide_WHT_Section(i, inputValues, handleInputChange);
            elementDisplay('#div_WHT_ddl' + i, false, "div");
            elementDisplay('#div_WHT_ddl2' + i, false, "div");

            handleInputChange(`ddlWHT${i}`, "0");
            handleInputChange(`txtWHTAmount${i}`, "0");
            handleInputChange(`txtWHTPercentage${i}`, "0");
            handleInputChange(`txtHouseNumber${i}`, "");
            handleInputChange(`txtWHTCity${i}`, "");
            handleInputChange(`txtWHTCompName${i}`, "");
            handleInputChange(`txtPostCode${i}`, "");
            handleInputChange(`txtTaxNumber${i}`, "");

            handleInputChange(`txtPayToComp${i}`, "0");
            handleInputChange(`txtPayToPerson${i}`, "0");
            handleInputChange(`txtOnePerc${i}`, "0");
            handleInputChange(`txtThreePerc${i}`, "0");
            handleInputChange(`txtFivePer${i}`, "0");
            handleInputChange(`hidden_WHT_Amount${i}`, objAttachment.wht_amount);

            //WHT2 section
            handleInputChange(`txtWHTAmount2${i}`, "0");
            handleInputChange(`txtWHTPercentage2${i}`, "");

            handleInputChange(`txtOnePerc2${i}`, "0");
            handleInputChange(`txtThreePerc2${i}`, "0");
            handleInputChange(`txtFivePer2${i}`, "0");
            handleInputChange(`hidden_WHT_Amount2`, objAttachment.wht_amount2);

        }
        //End of WHT tax default sectioin


        ////VAT Section
        //if (objtaxratechk[0].include_Vat) {
        //    $('#ddlVAT' + i).val(objAttachment.is_include_vat);
        //    $('.divVat_ddl').removeClass('d-none');
        //    if (objAttachment.is_include_vat) {
        //        $('.divVat').removeClass('d-none');
        //        $('#txtVAtPercentage' + i).val(objAttachment.vat_percent);
        //        $('#txtBaseAmount' + i).val(objAttachment.vat_amount);
        //        $('#txtVAtPercentage' + i).prop("disabled", true);
        //        $('#txtBaseAmount' + i).prop("disabled", true);
        //        $('#ddlBusinessPlace' + i).val(objAttachment.business_place);
        //        $('#txtCompName' + i).val(objAttachment.company_name);
        //        $('#txtHeadOffice' + i).val(objAttachment.head_office);
        //        $('#txtTaxId' + i).val(objAttachment.tax_id);


        //    }
        //    else {
        //        $('#txtBaseAmount' + i).val(0);
        //        $('#txtVAtPercentage' + i).val(0);
        //        $('#ddlBusinessPlace' + i).val('');
        //        $('#txtCompName' + i).val('');
        //        $('#txtHeadOffice' + i).val('');
        //        $('#txtTaxId' + i).val('');
        //    }

        //}
        //else {
        //    $('#ddlVAT' + i).val(0);
        //    $('#txtBaseAmount' + i).val(0);
        //    $('#txtVAtPercentage' + i).val(0);
        //    $('#ddlBusinessPlace' + i).val('');
        //    $('#txtCompName' + i).val('');
        //    $('#txtHeadOffice' + i).val('');
        //    $('#txtTaxId' + i).val('');
        //}

        ////Binding WHT Section
        //if (objtaxratechk[0].include_Wht) {
        //    $('.div_WHT_ddl').removeClass('d-none');
        //    if (objAttachment.is_include_wht) {
        //        $('#ddlWHT' + i).val(objAttachment.is_include_wht);
        //        $('.div_WHT').removeClass('d-none');
        //        $('#txtWHTAmount' + i).val(objAttachment.wht_amount);
        //        // $('#txtWHTAmount' + i).val(parseFloat(objAttachment.wht_amount).toFixed(2));
        //        $('#txtWHTPercentage' + i).val(objAttachment.wht_percent);
        //        $('#txtWHTAmount' + i).prop("disabled", true);
        //        $('#txtWHTPercentage' + i).val('1.5').prop("disabled", true);
        //        $('#txtHouseNumber' + i).val(objAttachment.house_number);
        //        $('#txtWHTCity' + i).val(objAttachment.wht_city);
        //        $('#txtWHTCompName' + i).val(objAttachment.wht_name);
        //        $('#txtPostCode' + i).val(objAttachment.postcode);
        //        $('#txtTaxNumber' + i).val(objAttachment.tax_number);
        //        if (objAttachment.wht_pay_to == 1 || objAttachment.wht_pay_to == '' || objAttachment.wht_pay_to == null || objAttachment.wht_pay_to == undefined) {
        //            $('#txtPayToComp' + i).prop('checked', true);
        //            $('#txtPayToPerson' + i).prop('checked', false);

        //        }

        //        if (objAttachment.wht_pay_to == 2) {
        //            $('#txtPayToPerson' + i).prop('checked', true);
        //            $('#txtPayToComp' + i).prop('checked', false);
        //        }
        //        if (objAttachment.wht_type == 1 || objAttachment.wht_type == '' || objAttachment.wht_type == null || objAttachment.wht_type == undefined) {
        //            $('#txtOnepointFivePerc' + i).prop('checked', true);
        //            $('#txtThreePerc' + i).prop('checked', false);
        //            $('#txtFivePer' + i).prop('checked', false);
        //        }
        //        else if (objAttachment.wht_type == 2) {
        //            $('#txtOnepointFivePerc' + i).prop('checked', false);
        //            $('#txtThreePerc' + i).prop('checked', true);
        //            $('#txtFivePer' + i).prop('checked', false);
        //        }
        //        else if (objAttachment.wht_type == 3) {
        //            $('#txtOnepointFivePerc' + i).prop('checked', false);
        //            $('#txtThreePerc' + i).prop('checked', false);
        //            $('#txtFivePer' + i).prop('checked', true);
        //        }


        //        else {
        //            $('#txtWHTAmount' + i).val(0);
        //            $('#txtWHTPercentage' + i).val(0);
        //            $('#txtHouseNumber' + i).val('');
        //            $('#txtWHTCity' + i).val('');
        //            $('#txtWHTCompName' + i).val('');
        //            $('#txtPostCode' + i).val('');
        //            $('#txtTaxNumber' + i).val('');
        //        }
        //    }
        //    else {
        //        $('#txtWHTCity' + i).val('');
        //        $('#txtWHTAmount' + i).val(0);
        //        $('#txtWHTPercentage' + i).val(0);
        //        $('#txtPayToComp' + i).prop('checked', false);
        //        $('#txtPayToPerson' + i).prop('checked', false);
        //        $('#txtOnepointFivePerc' + i).prop('checked', false);
        //        $('#txtThreePerc' + i).prop('checked', false);
        //        $('#txtFivePer' + i).prop('checked', false);
        //    }

        //}
        //else {
        //    $('#ddlWHT' + i).val(0);
        //    $('#txtWHTAmount' + i).val(0);
        //    $('#txtWHTPercentage' + i).val(0);

        //    $('#txtHouseNumber' + i).val('');
        //    $('#txtWHTCity' + i).val('');
        //    $('#txtWHTCompName' + i).val('');
        //    $('#txtPostCode' + i).val('');
        //    $('#txtTaxNumber' + i).val('');
        //    $('#txtPayToComp' + i).prop('checked', false);
        //    $('#txtPayToPerson' + i).prop('checked', false);
        //    $('#txtOnepointFivePerc' + i).prop('checked', false);
        //    $('#txtThreePerc' + i).prop('checked', false);
        //    $('#txtFivePer' + i).prop('checked', false);

        //}


    }
    else { //Non Thailand country, Thailand tax feature will automatically hide

        //VAT tax section     
        elementDisplay('#divVat_ddl' + i, false, "div");
        elementDisplay('.divVat', false, "div");
        handleInputChange(`ddlVAT${i}`, "0");
        handleInputChange(`txtBaseAmount${i}`, "0");
        handleInputChange(`txtVAtPercentage${i}`, "0");
        handleInputChange(`ddlBusinessPlace${i}`, "");
        handleInputChange(`txtCompName${i}`, "");
        handleInputChange(`txtHeadOffice${i}`, "");
        handleInputChange(`txtTaxId${i}`, "");

        //WHT tax section
        //  $('.div_WHT').addClass('d-none');
        hide_WHT_Section(i, inputValues, handleInputChange);
        elementDisplay('#div_WHT_ddl' + i, false, "div");
        elementDisplay('#div_WHT_ddl2' + i, false, "div");

        handleInputChange(`ddlWHT${i}`, "0");
        handleInputChange(`txtWHTAmount${i}`, "0");
        handleInputChange(`txtWHTPercentage${i}`, "0");
        handleInputChange(`txtHouseNumber${i}`, "");
        handleInputChange(`txtWHTCity${i}`, "");
        handleInputChange(`txtWHTCompName${i}`, "");
        handleInputChange(`txtPostCode${i}`, "");
        handleInputChange(`txtTaxNumber${i}`, "");

        handleInputChange(`txtPayToComp${i}`, "0");
        handleInputChange(`txtPayToPerson${i}`, "0");
        handleInputChange(`txtOnePerc${i}`, "0");
        handleInputChange(`txtThreePerc${i}`, "0");
        handleInputChange(`txtFivePer${i}`, "0");

        //WHT 2 Fields
        handleInputChange(`txtWHTAmount2${i}`, "0");
        handleInputChange(`txtWHTPercentage2${i}`, "");

        handleInputChange(`txtOnePerc2${i}`, "0");
        handleInputChange(`txtThreePerc2${i}`, "0");
        handleInputChange(`txtFivePer2${i}`, "0");
        handleInputChange(`hidden_WHT_Amount2`, "0");

        handleInputChange(`hidden_WHT_Amount`, "0");
        handleInputChange(`hidden_VAT_Amount`, "0");
    }

}

// export function loadInvoice_Number(
//     i: number | undefined, 
//     inputValues: { [key: string]: any | undefined },
//     handleInputChange: (id: string, value?: any) => Promise<void>, 
//     objAttachment:any
// ) {
    //let current_user_info = !isNullOrEmpty(localStorage.getItem("objRequestor")) ? JSON.parse(localStorage.getItem("objRequestor")!) : null;

    // if (current_user_info.country_code == 'TH' && inputValues[`ddlCurrency${i}`] == 'THB') {
        
    //     let checkCategory = false;
    //     //Catergory that invoice number will be hide
    //     if ((inputValues[`ddlTransportType${i}`] == '1' ||//Taxi/Rideshare
    //         inputValues[`ddlTransportType${i}`] == '2' ||//Mileage 
    //         inputValues[`ddlTransportType${i}`] == '3' ||//Public transport 
    //         inputValues[`ddlTransportType${i}`] == '5' ||//Train
    //         inputValues[`ddlTransportType${i}`] == '9' || //Parking
    //         inputValues[`ddlTransportType${i}`] == '10') && inputValues[`ddlCategory${i}`] == '4' ||
    //         inputValues[`ddlCategory${i}`] == '46' ||
    //         inputValues[`ddlCategory${i}`] == '47' ||
    //         inputValues[`ddlCategory${i}`] == '48') {

    //         checkCategory = true;
    //         enable_InvoiceNumber(i, handleInputChange, checkCategory, objAttachment);
    //     }
    //     else if (inputValues[`ddlCategory${i}`] == "16") { //Catergory that invoice number will be hide
    //         checkCategory = true;
    //         enable_InvoiceNumber(i, handleInputChange, checkCategory, objAttachment);
    //     } else if (inputValues[`ddlCategory${i}`] == "29" && (inputValues[`ddlDetailType${i}`] == "1" || inputValues[`ddlDetailType${i}`] == "3" || inputValues[`ddlDetailType${i}`] == "4")) {
    //         checkCategory = true;
    //         enable_InvoiceNumber(i, handleInputChange, checkCategory, objAttachment);
    //     } else if (inputValues[`ddlCategory${i}`] == '41') { //Catergory that invoice number will be hide Acc Allowance
    //         checkCategory = true;
    //         enable_InvoiceNumber(i, handleInputChange, checkCategory, objAttachment);
    //     } else if (inputValues[`ddlCategory${i}`] == '42') { //Catergory that invoice number will be hide Meal Allowance
    //         checkCategory = true;
    //         enable_InvoiceNumber(i, handleInputChange, checkCategory, objAttachment);
    //     } else { //Normal category that invoice number will be shown
    //         checkCategory = false;
    //         enable_InvoiceNumber(i, handleInputChange, checkCategory, objAttachment);
    //     }

    //     if (inputValues[`ddlCategory${i}`] == '41' || inputValues[`ddlCategory${i}`] == '42') { //Disable invoice amount
    //         disableInput(`#txtClaimAmount${i}`, true, "text");
    //     }

    // }



//}

export function loadInvoice_Number(
  i: number | undefined,
  inputValues: { [key: string]: any | undefined },
  handleInputChange: (id: string, value?: any) => Promise<void>,
  objAttachment: any,
  overrideShow?: boolean
) {
  if (i == null) return;

  const current_user_info = localStorage.getItem('objRequestor')
    ? JSON.parse(localStorage.getItem('objRequestor')!)
    : null;
  // Begin, Saber, 20260514, SR-959286, CHN-20860 Receipt number for MY(Except MY98) V3
  // ExpReport: use claim item owner's country/company code from objAttachment
  // ClaimItems: use logged-in user's country/company code from objRequestor
  const countryCode = overrideShow
    ? objAttachment?.country ?? current_user_info?.country_code
    : current_user_info?.country_code;
  const companyCode = overrideShow
    ? objAttachment?.company_code ?? current_user_info?.company_code
    : current_user_info?.company_code;
  // End, Saber, 20260514, SR-959286, CHN-20860 Receipt number for MY(Except MY98) V3
  if (!countryCode) return;

  // Centralized visibility logic (TH + other countries via rules)
  applyInvoiceVisibility(
    i,
    inputValues as Record<string, any>,
    countryCode,
    handleInputChange,
    elementDisplay,
    mandatoryInput,
    objAttachment,
    companyCode, // Saber, 20260514, SR-959286, CHN-20860, pass company code for MY98 exclusion
    overrideShow // Saber, 20260514, SR-959286, CHN-20860 Receipt number for MY(Except MY98) V3, ExpReport: use item owner's company code
  );

  

  // Country-specific label wording (KH override etc.)
  updateInvoiceLabel(countryCode);

  // Preserve legacy TH disable of claim amount for categories 41 & 42
  if (
    countryCode === 'TH' &&
    (inputValues[`ddlCategory${i}`] === '41' || inputValues[`ddlCategory${i}`] === '42')
  ) {
    disableInput(`#txtClaimAmount${i}`, true, 'text');
  }
}


export function enable_InvoiceNumber(
    i: number | undefined, 
    handleInputChange: (id: string, value?: any) => Promise<void>, 
    checkCategory:boolean,
    objAttachment:any
) {

    if (checkCategory) {
        //Hide invoice number for certain category
        elementDisplay(`.divTHB`, false, "div");
        handleInputChange(`txtInvoiceNum${i}`, "");
    }
    else {
        handleInputChange(`txtInvoiceNum${i}`, "");
        elementDisplay(`.divTHB`, true, "div");
        handleInputChange(`hidValidate_InvoiceNum${i}`, 1);

        //Bind invoice number value
        if (!isNullOrEmpty(objAttachment)  && objAttachment?.invoice_number ) {
            handleInputChange(`txtInvoiceNum${i}`, objAttachment?.invoice_number);
        }
    }
}

export function show_VAT_Section(
    i: number | undefined, 
    handleInputChange: (id: string, value?: any) => Promise<void>, 
) {
    elementDisplay(`#divVat_BusinessPlace${i}`, true, "div");
    handleInputChange(`ddlBusinessPlace${i}`, 0);

    elementDisplay(`#divVat_BaseAmount${i}`, true, "div");
    elementDisplay(`#divVat_Company${i}`, true, "div");
    elementDisplay(`#divVat_HeadOffice${i}`, true, "div");
}

export function hide_VAT_Section(
    i: number | undefined, 
    handleInputChange: (id: string, value?: any) => Promise<void>, 
) {
    elementDisplay(`#divVat_BusinessPlace${i}`, false, "div");
    handleInputChange(`ddlBusinessPlace${i}`, "");

    elementDisplay(`#divVat_BaseAmount${i}`, false, "div");
    elementDisplay(`#divVat_Company${i}`, false, "div");
    elementDisplay(`#divVat_HeadOffice${i}`, false, "div");
}

export function show_WHT_Section(
    i: number | undefined, 
    inputValues: { [key: string]: any | undefined },
    handleInputChange: (id: string, value?: any) => Promise<void>,
) {

    elementDisplay(`#divWHT_PayToPerson${i}`, true, "div");
    elementDisplay(`#divWHT_PaytoCompany${i}`, true, "div");
    elementDisplay(`#divWHT_Company${i}`, true, "div");
    elementDisplay(`#divWHT_Type${i}`, true, "div");
    elementDisplay(`#divWHT_TypeOne${i}`, true, "div");
    elementDisplay(`#divWHT_TypeThree${i}`, true, "div");
    elementDisplay(`#divWHT_TypeFive${i}`, true, "div");
    elementDisplay(`#divWHT_BaseAmount${i}`, true, "div");
    elementDisplay(`#divWHT_HouseNumber${i}`, true, "div");
    elementDisplay(`#divWHT_PostalCode${i}`, true, "div");

    //WHT2 Section
    if (inputValues[`ddlWHT2${i}`] == "1") {
        elementDisplay(`#divWHT_Type2${i}`, true, "div");
        elementDisplay(`#divWHT_TypeOne2${i}`, true, "div");
        elementDisplay(`#divWHT_TypeThree2${i}`, true, "div");
        elementDisplay(`#divWHT_TypeFive2${i}`, true, "div");
        elementDisplay(`#divWHT_BaseAmount2${i}`, true, "div");
    }
    show_WHT_Rates(i, inputValues, handleInputChange);
}

export function show_WHT_Rates_Control(
    i: number | undefined, 
    inputValues: { [key: string]: any | undefined },
    handleInputChange: (id: string, value?: any) => Promise<void>,
    objtaxratechk:any
){
    let wht_config = objtaxratechk.wht_config.split("|");
    let rateDefault = 0, rateDefault2 = 0;
    if (inputValues[`txtOnePerc${i}`] == 1 ) {
        rateDefault = 1;
    }
    if (inputValues[`txtThreePerc${i}`] == 1) {
        rateDefault = 3;
    }
    if (inputValues[`txtFivePer${i}`] == 1) {
        rateDefault = 5;
    }

    if (wht_config.includes("1.0")) {
        elementDisplay(`#divWHT_TypeOne${i}` , true, "div");
        if (rateDefault == 0) {
            handleInputChange(`txtOnePerc${i}` , 1);
            rateDefault = 1;
        }
        if (inputValues[`ddlWHT2${i}`] == 1) {
            if (rateDefault2 == 0 && rateDefault != 1) {

                handleInputChange(`txtOnePerc2${i}` , 1);
                handleInputChange(`txtThreePerc2${i}` , 0);
                handleInputChange(`txtFivePer2${i}` , 0);
                handleInputChange(`txtWHTPercentage2${i}` , 1);
                disableInput(`#txtWHTPercentage2${i}`, true, "text");

                rateDefault2 = 1;
            }
            elementDisplay(`#divWHT_TypeOne2` , true, "div");
        }
    }
    else {
        elementDisplay(`#divWHT_TypeOne${i}` , false, "div");
        handleInputChange(`txtOnePerc${i}` , 0);

        if (inputValues[`txtWHTPercentage${i}`] == 1) {
            handleInputChange(`txtWHTPercentage${i}` , "");
            disableInput(`#txtWHTPercentage${i}`, true, "text");
        }

        if (inputValues[`ddlWHT2${i}`] == 1) {
            //$('#divWHT_TypeOne2' + i).addClass('d-none');
            handleInputChange(`txtOnePerc2${i}` , 0);

            if (inputValues[`txtWHTPercentage2${i}`] == 1) {
                handleInputChange(`txtWHTPercentage2${i}` , "");
                disableInput(`#txtWHTPercentage2${i}`, true, "text");
            }
        }
    }

    if (wht_config.includes("3.0")) {
        elementDisplay(`#divWHT_TypeThree${i}`, true, "div");

        if (rateDefault == 0) {
            handleInputChange(`txtThreePerc${i}`, 1); // assuming checkbox input
            rateDefault = 3;
        }

        if (inputValues[`ddlWHT2${i}`] == 1) {
            if (rateDefault2 == 0 && rateDefault != 3) {
                handleInputChange(`txtOnePerc2${i}`, 0);
                handleInputChange(`txtThreePerc2${i}`, 1);
                handleInputChange(`txtFivePer2${i}`, 0);

                handleInputChange(`txtWHTPercentage2${i}`, 3);
                disableInput(`#txtWHTPercentage2${i}`, true, "text");

                rateDefault2 = 3;
            }
            elementDisplay(`#divWHT_TypeThree2${i}`, true, "div");
        }
    }
    else {
        elementDisplay(`#divWHT_TypeThree${i}`, false, "div");
        handleInputChange(`txtThreePerc${i}`, 0);

        if (inputValues[`txtWHTPercentage${i}`] == 3) {
            handleInputChange(`txtWHTPercentage${i}`, "");
            disableInput(`#txtWHTPercentage${i}`, true, "text");
        }

        if (inputValues[`ddlWHT2${i}`] == 1) {
            handleInputChange(`txtThreePerc2${i}`, 0);

            if (inputValues[`txtWHTPercentage2${i}`] == 3) {
                handleInputChange(`txtWHTPercentage2${i}`, "");
                disableInput(`#txtWHTPercentage2${i}`, true, "text");
            }
        }
    }

    if (wht_config.includes("5.0")) {

        elementDisplay(`#divWHT_TypeFive${i}`, true, "div");

        if (rateDefault == 0) {
            handleInputChange(`txtFivePer${i}`, 0); // assuming this is a checkbox
            rateDefault = 5;
        }

        if (inputValues[`ddlWHT2${i}`] == 1) {
            if (rateDefault2 == 0 && rateDefault != 5) {
                handleInputChange(`txtOnePerc2${i}`, 0);
                handleInputChange(`txtThreePerc2${i}`, 0);
                handleInputChange(`txtFivePer2${i}`, 1);

                handleInputChange(`txtWHTPercentage2${i}`, 5);
                disableInput(`#txtWHTPercentage2${i}`, true, "text");

                rateDefault2 = 5;
            }

            elementDisplay(`#divWHT_TypeFive2${i}`, true, "div");
        }
    } else {
        elementDisplay(`#divWHT_TypeFive${i}`, false, "div");
        handleInputChange(`txtFivePer${i}`, 0);

        if (inputValues[`txtWHTPercentage${i}`] == 5) {
            handleInputChange(`txtWHTPercentage${i}`, "");
            disableInput(`#txtWHTPercentage${i}`, true, "text");
        }

        if (inputValues[`ddlWHT2${i}`] == 1) {
            handleInputChange(`txtFivePer2${i}`, 0);

            if (inputValues[`txtWHTPercentage2${i}`] == 5) {
                handleInputChange(`txtWHTPercentage2${i}`, "");
                disableInput(`#txtWHTPercentage2${i}`, true, "text");
            }
        }
    }
}


export function show_WHT_Rates(
    i: number | undefined, 
    inputValues: { [key: string]: any | undefined },
    handleInputChange: (id: string, value?: any) => Promise<void>,
) {

    let current_user_information = !isNullOrEmpty(localStorage.getItem("objRequestor")) ? JSON.parse(localStorage.getItem("objRequestor")!) : null;
    let objtaxratechk = !isNullOrEmpty(localStorage.getItem("tax_rate_checking")) ? JSON.parse(localStorage.getItem("tax_rate_checking")!) : null;

    if (current_user_information.country_code == 'TH') {

        //Prompt current subcategory choose by user
        let current_subcategory = inputValues[`ddlCategory${i}`];
        let cur_transport_type = inputValues[`ddlTransportType${i}`];
        let cur_phone_type = inputValues[`ddlPhoneType${i}`];
        let cur_detail_type = inputValues[`ddlDetailType${i}`];

        //Enhanced WHT section
        if (objtaxratechk) {
            if (objtaxratechk.length > 0) {
                for (let j = 0; j < objtaxratechk.length; j++) {
                    //Display and bind value for VAT tax section
                    if (objtaxratechk[j].subcategory_id == current_subcategory && objtaxratechk[j].include_Wht == "1") {

                        //Non-detail type category
                        if (objtaxratechk[j].detail_id == null || objtaxratechk[j].detail_id == undefined) {
                            show_WHT_Rates_Control(i, inputValues, handleInputChange, objtaxratechk[j]);
                        }
                        //Transport type category
                        else if (objtaxratechk[j].detail_id == cur_transport_type && objtaxratechk[j].subcategory_id == '4') {

                            show_WHT_Rates_Control(i, inputValues, handleInputChange, objtaxratechk[j]);
                        }
                        //Phone Type category
                        else if (objtaxratechk[j].detail_id == cur_phone_type && objtaxratechk[j].subcategory_id == '26') {

                            show_WHT_Rates_Control(i, inputValues, handleInputChange, objtaxratechk[j]);
                        }

                        //Detail Type category (Exclude transport & phone)
                        else if (objtaxratechk[j].detail_id == cur_detail_type && objtaxratechk[j].subcategory_id == '29') {

                            show_WHT_Rates_Control(i, inputValues, handleInputChange, objtaxratechk[j]);
                        }
                    }
                }
            }
        }
    }
}

export function hide_WHT_Section(
    i: number | undefined, 
    inputValues: { [key: string]: any | undefined },
    handleInputChange: (id: string, value?: any) => Promise<void>,
) {
    elementDisplay(`#divWHT_PayToPerson${i}`, false, "div");
    elementDisplay(`#divWHT_PaytoCompany${i}`, false, "div");
    elementDisplay(`#divWHT_Company${i}`, false, "div");
    elementDisplay(`#divWHT_Type${i}`, false, "div");
    elementDisplay(`#divWHT_TypeOne${i}`, false, "div");
    elementDisplay(`#divWHT_TypeThree${i}`, false, "div");
    elementDisplay(`#divWHT_TypeFive${i}`, false, "div");
    elementDisplay(`#divWHT_BaseAmount${i}`, false, "div");
    elementDisplay(`#divWHT_HouseNumber${i}`, false, "div");
    elementDisplay(`#divWHT_PostalCode${i}`, false, "div");


    //WHT2 Section
    handleInputChange(`ddlWHT2${i}`, 0);
    elementDisplay(`#div_WHT_ddl2${i}`, false, "div");
    elementDisplay(`#divWHT_Type2${i}`, false, "div");
    elementDisplay(`#divWHT_TypeOne2${i}`, false, "div");
    elementDisplay(`#divWHT_TypeThree2${i}`, false, "div");
    elementDisplay(`#divWHT_TypeFive2${i}`, false, "div");
    elementDisplay(`#divWHT_BaseAmount2${i}`, false, "div");

}


//This function in charge of preventing certain claim item is being editable by the user. This claim item is only able to edit by HRBA user which is using the onbehalf control
//Claim item categories that is being affected
//Subcategory ID 29 and Detail ID 4 (Calamity Assistance)
export function th_HRBA_CONTROL(
    i: number | undefined, 
    inputValues: { [key: string]: any | undefined },
    handleInputChange: (id: string, value?: any) => Promise<void>,
    objRequestor:any, 
    objCreator:any, 
    objAttachment:any,
    HRBALIST:any, 
    form_mode:string
) 
{
    let chk_form_mode = form_mode;

    if (chk_form_mode == 'edit') {
        if (objRequestor.country_code == 'TH' && objAttachment.subcategory_id == '29' && objAttachment.detail_type == '4') {
            let TH_HRBA_USER = HRBALIST.split(',');
            let checking_control = false;

            //Allow edit for HRBA user to edit on behalf of other or themselves
            for (let a = 0; a < TH_HRBA_USER.length; a++) {
                if (objCreator.personnel_number == TH_HRBA_USER[a] && objCreator.personnel_number == objAttachment.creator_user_id) {
                    checking_control = true;
                    break;
                }
            }

            //If user create themselves, they can edit or delete it
            //This scenario will happened if user create themselves
            if (objCreator.personnel_number == objAttachment.creator_user_id) {
                checking_control = true;
            }

            if (checking_control) {
                chk_form_mode = 'edit';
                return chk_form_mode;
            } else {
                chk_form_mode = 'view';
                return chk_form_mode;
            }
        } else {
            chk_form_mode = 'edit';
            return chk_form_mode;
        }
    } else {
        return chk_form_mode;
    }
}


export function th_HRBA_CONTROL_EXP_REPORT(
    i: number | undefined, 
    inputValues: { [key: string]: any | undefined },
    handleInputChange: (id: string, value?: any) => Promise<void>,
    HRBALIST:any, 
    currentStatusName:string, 
    currentStatus:string
) {
    let objRequestor = !isNullOrEmpty(localStorage.getItem("objRequestor")) ? JSON.parse(localStorage.getItem("objRequestor")!) : null;
    let objCreator = !isNullOrEmpty(localStorage.getItem("objCreator")) ? JSON.parse(localStorage.getItem("objCreator")!) : null;

    if (currentStatusName != "New") {
        if (objRequestor.country_code == 'TH') {

            let TH_HRBA_USER = HRBALIST.split(',');
            let is_calamity = false;
            let is_user_hrba = false;
            let dtlItemObj = !isNullOrEmpty(localStorage.getItem("ExpReportDtlItemsData")) ? JSON.parse(localStorage.getItem("ExpReportDtlItemsData")!) : null; 

            for (let a = 0; a < dtlItemObj.length; a++) {
                if (dtlItemObj[a].subcategory_id == '29' && dtlItemObj[a].detail_type == '4') {
                    is_calamity = true;

                    //Allow edit for HRBA user to edit on behalf of other or themselves
                    for (let j = 0; j < TH_HRBA_USER.length; j++) {
                        if (objCreator.personnel_number == TH_HRBA_USER[j] && objCreator.personnel_number == dtlItemObj[j].creator_user_id) {
                            is_user_hrba = true;
                            break;
                        }
                    }

                    //User is found and correct break from the first circle
                    //Able to identify calamity claim is within th expense report
                    if (is_user_hrba && is_calamity) {
                        break;
                    }

                }
            }

            if (dtlItemObj && dtlItemObj.length > 0) {
                if (objCreator.personnel_number != dtlItemObj[0].creator_user_id) {
                    if (is_calamity && !(is_user_hrba)) {
                        //hide button for all status where it will not allow HRBA created on behalf claim is being edit by the user
                        elementDisplay(`#btnExpDetailWithdraw`, false, "div");
                        elementDisplay(`#btnExpDetailSaveDraft`, false, "div");
                        elementDisplay(`#btnExpDetailSubmit`, false, "div");
                        elementDisplay(`#btnExpDetailCancel`, false, "div");

                        //hide all delete button in table claim
                        const elements = document.querySelectorAll<HTMLElement>(".HRBAHideControl");
                        elements.forEach((elem) => {
                            elem?.classList?.add("d-none");
                        });
                    }
                }
            }
        }
    }
}


export function validateWHTPercentage(
    i: number | undefined, 
    inputValues: { [key: string]: any | undefined },
) {
    let wht1_perc = 0, wht2_perc = 0;
    if (inputValues[`ddlWHT2${i}`] == 1) {
        if (inputValues[`txtOnePerc${i}`] == 1) {
            wht1_perc = 1;
        }
        if (inputValues[`txtThreePerc${i}`] == 1) {
            wht1_perc = 3;
        }
        if (inputValues[`txtFivePer${i}`] == 1 ) {
            wht1_perc = 5;
        }
        if (inputValues[`txtOnePerc2${i}`] == 1 ) {
            wht2_perc = 1;
        }
        if (inputValues[`txtThreePerc2${i}`] == 1) {
            wht2_perc = 3;
        }
        if (inputValues[`txtFivePer2${i}`] == 1) {
            wht2_perc = 5;
        }
        if (wht1_perc == wht2_perc)
            return true;
        else
            return false;
    }
    else {
        return false;
    }
}


export function enableBaseAmount(
    i: number | undefined, 
    inputValues: { [key: string]: any | undefined },
) {

    //New code to always enable the base amount field
    disableInput(`#txtBaseAmount${i}`, false, "text");
    disableInput(`#txtWHTAmount${i}`, false, "text");
    disableInput(`#txtWHTAmount2${i}`, false, "text");

    if (inputValues[`ddlWHT2${i}`] == 1) {
        disableInput(`#txtWHTAmount2${i}`, false, "text");
    }
    else {
        disableInput(`#txtWHTAmount2${i}`, true, "text");
    }

    //The below code is the original code that handles the disable / enable of the  base field, commented out to always enable

    //if ($('#ddlWHT2' + i).val() == 1) {
    //    if ($('#ddlVAT' + i).val() == 1) {
    //        $('#txtBaseAmount' + i).removeAttr('disabled');
    //    }
    //    $('#txtWHTAmount' + i).removeAttr('disabled');
    //    $('#txtWHTAmount2' + i).removeAttr('disabled');


    //}
    //else {
    //    $('#txtBaseAmount' + i).attr('disabled', 'true');
    //    $('#txtWHTAmount' + i).attr('disabled', 'true');
    //    $('#txtWHTAmount2' + i).attr('disabled', 'true');
    //}
}


